import type { FC } from 'react'
import { Button } from "@chakra-ui/react"
import { MdOutlineAddShoppingCart } from "react-icons/md"
import { Link as RouterLink} from "react-router-dom"

export const BuyButton: FC<{text?: string, productBuyPath?: string}> = ({text = 'Do koszyka', productBuyPath}) => {

  if (!productBuyPath) {
    return (
      <Button 
        as='a'
        colorScheme={'primary'}
        isDisabled
        width={{base: '100%', md: 'inherit'}}
        padding={{base: 6, md: 4}}
        _hover={{bgColor: '#e54903'}}
        variant={'solid'}>
          Wkrótce dostępny
      </Button>  
    )
  }

  return (
    <Button 
      borderColor={'blackAlpha.400'}
      borderWidth={2}
      colorScheme={'primary'}
      padding={{base: 6, md: 4}}
      width={{base: '100%', md: 'inherit'}}
      _hover={{bgColor: '#e54903'}}
      leftIcon={<MdOutlineAddShoppingCart size={20} />} 
      as={RouterLink} 
      boxShadow={'inner'}
      rel={'nofollow'}
      to={productBuyPath} 
      variant={'solid'}>
        {text}
    </Button>  
  )
}